export const RGB_COLORS = [
  {
    id: 0,
    r: 206,
    g: 61,
    b: 149
  },
  {
    id: 1,
    r: 237,
    g: 44,
    b: 103
  },
  {
    id: 2,
    r: 251,
    g: 174,
    b: 23
  },
  {
    id: 3,
    r: 15,
    g: 182,
    b: 148
  },
  {
    id: 4,
    r: 145,
    g: 171,
    b: 242
  },
  {
    id: 5,
    r: 239,
    g: 78,
    b: 69
  },
  {
    id: 6,
    r: 244,
    g: 129,
    b: 50
  },
  {
    id: 7,
    r: 179,
    g: 186,
    b: 53
  },
  {
    id: 8,
    r: 114,
    g: 190,
    b: 68
  },
  {
    id: 9,
    r: 147,
    g: 0,
    b: 118
  },
  {
    id: 10,
    r: 169,
    g: 25,
    b: 79
  },
  {
    id: 11,
    r: 167,
    g: 98,
    b: 0
  },
  {
    id: 12,
    r: 31,
    g: 127,
    b: 107
  },
  {
    id: 13,
    r: 75,
    g: 75,
    b: 144
  },
  {
    id: 14,
    r: 188,
    g: 39,
    b: 38
  },
  {
    id: 15,
    r: 185,
    g: 73,
    b: 7
  },
  {
    id: 16,
    r: 114,
    g: 125,
    b: 33
  },
  {
    id: 17,
    r: 114,
    g: 190,
    b: 68
  },
  {
    id: 18,
    r: 86,
    g: 0,
    b: 84
  },
  {
    id: 19,
    r: 105,
    g: 0,
    b: 49
  },
  {
    id: 20,
    r: 128,
    g: 70,
    b: 0
  },
  {
    id: 21,
    r: 0,
    g: 76,
    b: 79
  },
  {
    id: 22,
    r: 53,
    g: 47,
    b: 102
  },
  {
    id: 23,
    r: 129,
    g: 0,
    b: 8
  },
  {
    id: 24,
    r: 135,
    g: 50,
    b: 0
  },
  {
    id: 25,
    r: 80,
    g: 95,
    b: 33
  },
  {
    id: 26,
    r: 0,
    g: 88,
    b: 45
  },
  {
    id: 27,
    r: 123,
    g: 31,
    b: 85
  },
  {
    id: 28,
    r: 158,
    g: 54,
    b: 57
  },
  {
    id: 29,
    r: 160,
    g: 107,
    b: 4
  },
  {
    id: 30,
    r: 32,
    g: 114,
    b: 98
  },
  {
    id: 31,
    r: 61,
    g: 59,
    b: 113
  },
  {
    id: 32,
    r: 179,
    g: 24,
    b: 15
  },
  {
    id: 33,
    r: 174,
    g: 76,
    b: 8
  },
  {
    id: 34,
    r: 95,
    g: 99,
    b: 28
  },
  {
    id: 35,
    r: 65,
    g: 111,
    b: 37
  },
  {
    id: 36,
    r: 0,
    g: 78,
    b: 174
  },
  {
    id: 37,
    r: 98,
    g: 25,
    b: 69
  },
  {
    id: 38,
    r: 128,
    g: 10,
    b: 46
  },
  {
    id: 39,
    r: 130,
    g: 87,
    b: 2
  },
  {
    id: 40,
    r: 25,
    g: 91,
    b: 78
  },
  {
    id: 41,
    r: 51,
    g: 49,
    b: 94
  },
  {
    id: 42,
    r: 150,
    g: 20,
    b: 13
  },
  {
    id: 43,
    r: 145,
    g: 64,
    b: 6
  },
  {
    id: 44,
    r: 72,
    g: 75,
    b: 21
  },
  {
    id: 45,
    r: 52,
    g: 88,
    b: 29
  },
  {
    id: 46,
    r: 0,
    g: 65,
    b: 143
  },
  {
    id: 47,
    r: 66,
    g: 17,
    b: 46
  },
  {
    id: 48,
    r: 90,
    g: 7,
    b: 34
  },
  {
    id: 49,
    r: 90,
    g: 60,
    b: 2
  }
];
